import React from 'react'
import { Tooltip } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'
import ResultButton from './ResultButton'

const GoToCnvDashboard = ({ analysisWrapperId, cnvType = null, label = 'CNV' }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    const typeParam = cnvType ? `?type=${cnvType}` : ''
    navigate(`/libra/cnv/${analysisWrapperId}${typeParam}`)
  }

  const isSv = cnvType === 'ont-sv' || cnvType === 'pacbio-sv' || cnvType === 'vcf-sv'

  return (
    <Tooltip title={isSv ? 'Structural variants' : 'Copy-number variants'} arrow>
      <ResultButton onClick={handleClick}>{label}</ResultButton>
    </Tooltip>
  )
}

export default GoToCnvDashboard
